import React, { Component } from "react";
import { Col, Form, Button, FormGroup, } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import UserService from "../../../services/UserService";
import HandleError from "../../../services/HandleError";
import LoaderInline from "../../helpers/LoaderInline";
import LoadingSVG from "../../helpers/LoadingSVG";
import Materialicon from "../../helpers/Materialicon";

class NotificationsForm extends Component {

    state = {
    	formData: {},
    	errors: {},
    	subscriptions: [],
    	isSaving: false
    }
	
	componentDidMount = () => { this.getSubscriptions(); }

	onCheckboxChange = (e, subscription) => {
    	this.setState({
			...this.state, 
			formData: {
				...this.state.formData, 
				[e.target.name]: e.target.checked 
			},
			subscriptions: this.state.subscriptions.map((item)=> (
				item.id !== subscription.id ? item : {
					...item,
					value: e.target.checked
				}
			))
		});
	}

	onSubmit = (e) => {
		e.preventDefault();
		this.setState({isSaving:true});
		this.userService.update(null,this.state.formData).then((res) => {
			this.setState({
				isSaving: false,
				subscriptions: this.mapSubscriptions(res.data),
				formData: res.data || []
			});
			NotificationManager.success("Notifications saved.");
		}).catch((err) => {
			this.setState({isSaving:false});
			HandleError(err, this);
		});;
	}
	
	getSubscriptions = () => {
		this.setState({isLoadingSubscriptions: true});
		this.userService.index(0).then((res) => {
			this.setState({
				isLoadingSubscriptions: false,
				subscriptions: this.mapSubscriptions(res.data),
				formData: res.data || []
			});
		}).catch((err) => {
			this.setState({isLoadingSubscriptions: false});
			HandleError(err, this);
		});
	}

	mapSubscriptions = (subscriptions) => {
		const tempSubscriptions = [];
		if(subscriptions && typeof(subscriptions) === "object") {
			Object.entries(subscriptions).forEach(([property,val], index) => {
				tempSubscriptions.push({name:property, value: val, id: index});
			});
			return tempSubscriptions;
		}
		return [];
	}

	userService = new UserService(this, "subscriptions")

	render() {
		const { subscriptions, errors, isSaving, } = this.state;
    	return (
    		<div className="settings-form notification-form">
				{   this.state.isLoadingSubscriptions ? <LoadingSVG /> 
					: 
					<React.Fragment>
						{ subscriptions && subscriptions.length > 0 ? 
							<Form horizontal onSubmit={this.onSubmit}>
								{  subscriptions.map((item)=>(
									<FormGroup validationState={errors.old_password && "error"} key={item.id}>
										<Col md={12}>
											<div className="checkbox">
												<input id={item.name} type="checkbox" name={item.name} checked={item.value} onChange={(e)=>this.onCheckboxChange(e,item)} />
												<label htmlFor={item.name}>{item.name}</label>
											</div>
										</Col>
									</FormGroup> 	
								))
								}
								<FormGroup>
									<Col md={12}>
										<Button type="submit" disabled={isSaving} bsStyle="primary" className="withIcon btn-crud">{isSaving?"Saving...":"Save"}</Button>
										{isSaving && <LoaderInline width="30" height="30" color="#2196f3"/> }
									</Col>
								</FormGroup>
							</Form>
							:
							<div className="no-subscriptions">
								<Materialicon icon="error_outline" />
								<h5>There are no subscriptions avaliable for you !</h5>
							</div>
						}
					</React.Fragment>
				}
    		</div>
    	);
	}
}

export default NotificationsForm;


// WEBPACK FOOTER //
// ./src/components/forms/users/NotificationsForm.js